export default __webpack_public_path__ + "6b4f0ec44b64108c04eb0125a499ebca.png";